import React from 'react';
import PropTypes from 'prop-types';

import { PAYMENT_METHOD_ICON_COMPONENT_MAPPING } from '../PaymentMethodIcon';

const getStyles = (type, ownType) => {
    return {
        filter: type && type !== ownType ? 'grayscale(1)' : null
    };
};

const CardTypeIcon = ({ type = null, configTypes = [] }) => {
    return (
        <div className="wz-lyriapay-payline-cardtypeicons-container">
            {configTypes.map(cardType => {
                const Component = PAYMENT_METHOD_ICON_COMPONENT_MAPPING[cardType.type];
                return (
                    Component && (
                        <Component
                            key={cardType.type}
                            className="wz-lyriapay-payline-cardtypeicon"
                            style={getStyles(type, cardType.type)}
                        />
                    )
                );
            })}
        </div>
    );
};

CardTypeIcon.propTypes = {
    type: PropTypes.string,
    configTypes: PropTypes.array.isRequired
};

export default CardTypeIcon;
